/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import styles from './themes/ConfirmationLight.css';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import classnames from 'classnames';
import ArrowRightIcon from 'zignal-landscape/lib/Icon/ArrowRightIcon';
import UnshowIcon from 'zignal-landscape/lib/Icon/UnshowIcon';
import moment from 'moment';
import { convertDatePickerTimeToMoment } from '../../../helpers/timeFormat';

const Confirmation = ({wizardStore, profileOptions, smartFilters}) => {

  const getDateRangeLabel = (startDateString, endDateString, inputDisplayFormat, timezone) => {
    const isNow = endDateString==='now';
    const startDate =convertDatePickerTimeToMoment(startDateString);
    const endDate = convertDatePickerTimeToMoment(endDateString);
    const isStartOfDay = startDate.isSame(
      startDate.clone().startOf('day'),
      'minute'
    );
    const isEndOfDay = endDate.isSame(endDate.clone().endOf('day'), 'minute');
    const simplifiedFormat = 'MM/DD/YYYY';

    const formatStart = isStartOfDay ? simplifiedFormat : inputDisplayFormat;
    const formatEnd = isEndOfDay ? simplifiedFormat : inputDisplayFormat;
    if (isStartOfDay && isEndOfDay) {
      if (startDate.isSame(endDate, 'day')) {
        return `${startDate.format(formatStart)} (${moment.tz(timezone).zoneName()})`;
      }
      return `${startDate.format(formatStart)} - ${endDate.format(formatEnd)} (${moment.tz(timezone).zoneName()})`;
    }
    return `${startDate.format(formatStart)} - ${
      isNow
        ? `Now (${moment.tz(timezone).zoneName()})`
        : `${endDate.format(formatEnd)} (${moment.tz(timezone).zoneName()})`
    }`;
  };

  const ROW_CHAR_LIMIT = 20;
  const { widgetSettings, timezone } = wizardStore;
  const renderConfirmationRow =(setting, key) => {
    let isRemove = setting.selected &&
      (!setting.value || setting.value.length === 0);

    let header = setting.header;
    if(!setting.visible || !setting.selected){
      return null;
    }

    let settingValue = setting.value || '';
    let multiLineDisplayRequired = key === 'candidates';
    if(key === 'widget_filter' && settingValue){
      settingValue = smartFilters.find((filter) => filter.value === settingValue).label;
    }
    if(key.includes('candidate')){
      settingValue = profileOptions.filter((filter) => settingValue.includes(filter.value))
        .map((option) => option.label).join();
      header = key === 'candidate' ? 'Dataset': 'Multi-Dataset';
    }
    if(isRemove && key !== 'dateRange_option') {
      settingValue = `No ${widgetSettings[key].header}`;
      if(key.includes('candidate')) {
        settingValue = 'No Default Set';
      }
    }
    if(key === 'dateRange_option') {
      if(setting.value !== null){
        const dateRangeLabel = getDateRangeLabel(settingValue.startDate, settingValue.endDate,
          'MM/DD/YYYY h:mma', timezone);
        settingValue = settingValue.timeStartWindow ?
          settingValue.timeStartWindow : dateRangeLabel;

        if(settingValue.length > ROW_CHAR_LIMIT) {
          multiLineDisplayRequired = false;
          settingValue = settingValue.replace(' - ', '\n - ');
        }
      }
      if(setting.value === null) {
        settingValue= 'Dashboard Date Range';
        isRemove=true;
      }
    }

    const fieldvalueClassNames = {
      [styles.fieldvalue]: true,
      [styles.apply]: !isRemove,
    };

    const renderDoNotDisplayIcon = () =>(
      <ToolTip
        position="top"
        tooltipText="Do Not Display"
        width={100}
      >
        <span className={styles.tooltipIcon}><UnshowIcon /></span>
      </ToolTip>
    );
    if (!Array.isArray(settingValue) && key !== 'dateRange_option' && !multiLineDisplayRequired) {
      if(settingValue.length > ROW_CHAR_LIMIT) {
        const settingDisplayRows = [];
        let currRowStartIndex = 0;
        let currRowEndIndex = ROW_CHAR_LIMIT;
        while(currRowStartIndex < settingValue.length){
          /*
            rewind endindex till endIndex char is space
          */
          while(currRowEndIndex > currRowStartIndex
            && settingValue.charCodeAt(currRowEndIndex) !== 32
            && currRowEndIndex< settingValue.length){
            --currRowEndIndex;
          }
          //if no space found take whole word(start-endindex)
          if(currRowEndIndex === currRowStartIndex){
            currRowEndIndex = currRowStartIndex + ROW_CHAR_LIMIT;
          }
          const currRowValue = settingValue.substring(currRowStartIndex, currRowEndIndex +1);
          settingDisplayRows.push(currRowValue);
          currRowStartIndex = currRowEndIndex;
          currRowEndIndex += ROW_CHAR_LIMIT;
        }
        settingValue = settingDisplayRows.join('\n');
      }

    }
    const settingValueArray = multiLineDisplayRequired ? settingValue.split(',') : [settingValue];

    return(
      <React.Fragment key={key}>
        <div className={classnames(styles.firstColumn, styles.items)} data-cy={`confirmation_header_${key}`}>
          {header}
        </div>
        <div className={classnames(styles.secondColumn, styles.items)}>
          <ArrowRightIcon width="20em" height="30px" />
        </div>
        <div className={classnames(styles.thirdColumn, styles.items)}>
          {settingValueArray.map((value, index)=>{
            return(
              <div key={`${index}_${value}`} className={styles.multiItems}>
                <span
                  className={classnames(fieldvalueClassNames)}
                  data-cy={`confirmation_value_${key}_${index}`}
                >
                  {setting.doNotDisplay && index === 0 && renderDoNotDisplayIcon()}
                  {value}
                </span>
              </div>
            );
          })}
        </div>
        <div className={classnames(styles.itemsunderlinerow)} />
      </React.Fragment>
    );
  };

  return (
    <div className={styles.confirmationContainer}>
      <div className={styles.messagerow} data-cy={'confirmation_header'}>
        Please review your changes before clicking Apply.
      </div>
      <div className={classnames(styles.firstColumn, styles.header)}>Fields</div>
      <div className={classnames(styles.secondColumn)} />
      <div className={classnames(styles.thirdColumn, styles.header)}>Updates To</div>
      {
        Object.keys(widgetSettings).map((key)=> renderConfirmationRow(widgetSettings[key], key))
      }
    </div>
  );
};

Confirmation.propTypes = {
  wizardStore: PropTypes.object,
  profileOptions:  PropTypes.array,
  smartFilters:  PropTypes.array,
};

export default themeable(Confirmation);
